import { CircularProgress } from "@remo-co/ui-core/src/components/CircularProgress";
import { Container } from "@remo-co/ui-core/src/components/Container";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { useI18n } from "i18n";

export const LoadingDevices = () => {
  const { t } = useI18n(["common", "micCamCheck"]);
  return (
    <Container
      fullWidth
      flex
      column
      alignItems="center"
      justifyContent="center"
      data-testid="loading-devices"
    >
      <CircularProgress />
      <Typography>{t("loading")}</Typography>
    </Container>
  );
};
